import type { ApiError, AxiosError } from './api.types';
import { ApiException } from './api.types';

export function autoBindDecorator<T extends object>(service: T) {
  return new Proxy(service, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver);
      return typeof value === 'function' ? value.bind(target) : value;
    },
  });
}

export function isAxiosError(obj: unknown): obj is AxiosError {
  return typeof obj === 'object' && obj !== null && 'errorMessage' in obj && 'errorCode' in obj;
}

export function isApiError(error: unknown): error is ApiError {
  return (
    typeof error === 'object'
    && error !== null
    && 'message' in error
    && 'type' in error
    && 'statusCode' in error
    && 'data' in error
  );
}

export function extractValidationErrors(error: ApiError) {
  return error.type === ApiException.ValidationException
    ? error.data?.errors ?? null
    : null;
}
